.noResults {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--bi-scale-4x);
    text-align: center;
    padding: var(--bi-scale-40x) var(--bi-scale-20x);

    @media (width < 600px) {
        padding: var(--bi-scale-20x) var(--bi-scale-10x);
    }

    > p {
        color: var(--bi-neutral-70);
        font-family: 'museo-sans', Arial, sans-serif;
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.5;
    }
}
